<template>
  <div>
    <div class="col-md-12 no-padding no-margin row">
      <div class="col-12 mt-3 mb-3">
        <h4
          class="text-center"
          v-html="title"/>
      </div>
      <div
        v-for="(app, index) in mapApps"
        :key="index"
        class="col-md-12 col-lg-6"
      >
        <div class="col-md-12 card">
          <div class="top">
            <div
              :style="'background:' + $t(app.translate + '.bgcolor')"
              class="icon">
              <i :class="$t(app.translate + '.icon')"/>
            </div>
            <div class="details">
              <strong>{{ $t(app.translate + '.fullname') }}</strong>
              <p>{{ $t(app.translate + '.description') }}</p>
            </div>
          </div>
          <div class="footer row">
            <div class="col-md-12">
              <template>
                <div v-if="app.app_id == 7 || app.app_id == 9 || app.app_id == 10">
                  <span style="position: relative;top: 18px;color: #D4D4D4;">(Coming Soon)</span>
                </div>
                <div
                  v-else
                  class="d-flex justify-content-between align-items-center h-100">
                  <div>
                    <span style="color: #D4D4D4;">
                      {{ app.moduleStatusText }}
                    </span>
                  </div>
                  <div class="text-right">
                    <button
                      :data-v-step="`appid${app.app_id}`"
                      :class="['btn', app.buttonColor]"
                      @click="handleClickInstallApp(app)"
                    >
                      {{ app.buttonText }}
                    </button>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-tour
      v-for="(app, index) in recommendInstallApps"
      :key="index"
      :name="`appid${app.appid}`"
      :steps="app.steps"
      :options="tourOptions"
      :class="`install-apps appid${app.appid}`"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import tourMinin from '@/mixins/tour'
import { app } from 'firebase'

const RECOMMEND_INSTALL_APPS = [
  {
    appid: 1,
    lists: [
      {
        translate: 'POS',
        interesting_ref: ['POS'],
      },
      {
        translate: 'MENU_ONLINE',
        interesting_ref: ['MENU_ONLINE'],
      },
    ],
  },
  {
    appid: 2,
    lists: [
      {
        translate: 'PRODUCT',
        interesting_ref: ['PRODUCT', 'POS', 'MENU_ONLINE', 'INVENTORY', 'SO_PO_INV', 'ACCOUNTING'],
      },
    ],
  },
  {
    appid: 3,
    lists: [
      {
        translate: 'INVENTORY',
        interesting_ref: ['INVENTORY'],
      },
    ],
  },
  {
    appid: 4,
    lists: [
      {
        translate: 'PO',
        interesting_ref: ['SO_PO_INV'],
      },
    ],
  },
  {
    appid: 5,
    lists: [
      {
        translate: 'SO',
        interesting_ref: ['SO_PO_INV'],
      },
    ],
  },
  {
    appid: 8,
    lists: [
      {
        translate: 'REPORT',
        interesting_ref: ['REPORT'],
      },
    ],
  },
  {
    appid: 12,
    lists: [
      {
        translate: 'ACCOUNTING',
        interesting_ref: ['ACCOUNTING', 'SO_PO_INV'],
      },
    ],
  },
  {
    appid: 13,
    lists: [
      {
        translate: 'HRM',
        interesting_ref: ['HRM_PAYROLL'],
      },
    ],
  },
  {
    appid: 14,
    lists: [
      {
        translate: 'PAYROLL',
        interesting_ref: ['HRM_PAYROLL'],
      },
    ],
  },
]

export default {
  mixins: [tourMinin],
  props: {
    title: String,
    apps: Array,
    installed: Array,
    pricing: Object,
  },
  data () {
    return {
      recommendInstallApps: [],
    }
  },
  computed: {
    ...mapGetters({
      shopInfo: 'getShopInfo',
    }),
    mapApps () {
      return this.apps.map((app) => {
        const moduleInstalled = (() => {
          const item = this.installed.find((item) => item.app_id === app.app_id)
          if (item) {
            return item.modules.length
          }
          return 0
        })()
        const hasInstalledApps = moduleInstalled > 0
        return {
          ...app,
          moduleInstalled,
          moduleStatusText: this.$t('apps.installapp.message.enabledmodules', { number: moduleInstalled }),
          buttonText: hasInstalledApps
            ? this.$t('apps.installapp.button.editapp')
            : this.$t('apps.installapp.button.installapp'),
          buttonColor: hasInstalledApps
            ? 'btn-light'
            : 'btn-web',
        }
      })
    },
  },
  methods: {
    ...mapActions('treesoft', {
      getPricing: 'getPricing',
    }),
    handleClickInstallApp (app) {
      this.$emit('onClickInstallApp', app)
    },
    setRecommendInstallApps() {
      try {
        this.recommendInstallApps = RECOMMEND_INSTALL_APPS
          // filter installed app
          .filter((app) => !this.isInstallApp({ app_id: app.appid }))
          // filter interesting - apps
          .filter((app) => {
            if (this.shopInfo.register && this.shopInfo.register.interesting) {
              return app.lists.reduce((acc, cur) => {
                cur.interesting_ref.forEach((interestingItem) => {
                  if (this.shopInfo.register.interesting[interestingItem]) {
                    acc = true
                  }
                })
                return acc
              }, false)
            }
            return false
          })
          // filter interesting - modules
          .reduce((acc, cur) => {
            const alwaysShowAppIds = [2]
            if (alwaysShowAppIds.includes(cur.appid)) {
              acc.push(cur)
            } else {
              const newItem = {
                ...cur,
                lists: cur.lists.filter((listItem) => {
                  return this.shopInfo.register.interesting[listItem.interesting_ref[0]]
                }),
              }
              acc.push(newItem)
            }
            return acc
          }, [])
          // not empy lists
          .filter((app) => app.lists.length)
          .map((app) => {
            return {
              ...app,
              steps: app.lists.map((list) => {
                return {
                  target: `[data-v-step="appid${app.appid}"]`,
                  header: {
                    title: `<b>${this.$t('message.recommendinstallapp')}</b>`,
                  },
                  content: (() => {
                    if (app.lists.length == 1) {
                      return this.$t(`business.interesting.${app.lists[0].translate}`)
                    } else {
                      return app.lists.map((list) => {
                        return `- ${this.$t(`business.interesting.${list.translate}`)}`
                      }).join('<br/>')
                    }
                  })(),
                  params: {
                    placement: 'left',
                    enableScrolling: false,
                  },
                }
              }),
            }
          })
        this.$nextTick(() => {
          this.recommendInstallApps.forEach((app) => {
            this.$tours[`appid${app.appid}`].start()
          })
        })
      } catch (err) {
        return []
      }
    },
  },
  mounted() {
    this.setRecommendInstallApps()
  },
  updated() {
    /// remove recommended if app is installed
    this.recommendInstallApps.forEach((app) => {
      if (this.isInstallApp({ app_id: app.appid })) {
        document.querySelectorAll(`.install-apps.appid${app.appid}`).forEach((el) => el.remove())
      }
    })
  },
}
</script>

<style scoped>
  #content .content {
    padding-top: 18px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .card {
    background: #FFF;
    border: solid 1px #D8E2E7;
    border-radius: 2px;
    padding: 15px 15px 0 15px;
    margin: 10px 0 15px 0;
  }
  .card .top {
    width: 100%;
    left: left;
    padding-bottom: 15px;
    border-bottom: solid 1px #D8E2E7;
  }
  .card .top .icon {
    width: 70px;
    height: 70px;
    float: left;
    margin-right: 15px;
    text-align: center;
  }
  .card .top .icon i {
    position: relative;
    top: 18px;
    font-size: 36px;
    color: #FFF;
  }
  .card .top .details {
    width: -webkit-calc(100% - 70px - 15px);
  	width:    -moz-calc(100% - 70px - 15px);
  	width:         calc(100% - 70px - 15px);
    float: left;
    max-height: 72px;
    overflow: auto;
  }
  .card .top .details p {
    margin: 0;
  }
  .card .footer {
    min-height: 53.8px;
  }
  .card .footer .label {
    color: #D4D4D4;
    font-size: 15px;
    margin: 18px 0 0 0;
  }
  .card .footer a {
    float: right;
    margin: 18px 0 15px 0;
  }
  @media (max-width: 992px) {
    .card .footer a {
      margin: 0 0 15px 0;
    }
  }
</style>

<style>
.v-tour.install-apps .v-step__content {
  margin-bottom: 0;
  text-align: left;
}
.v-tour.install-apps .v-step__buttons {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseInstallApps.vue